import helper from '@/libs/forms';

export default {
  schema: () => ({
    fields: [
      {
        type: 'radios',
        label: 'How do you want to search properties?',
        model: 'apnOrAddress',
        required: true,
        styleClasses: 'col-md-12 inline-radio',
        values: [
          { name: 'Address', value: 'address' },
          { name: 'APN', value: 'apn' },
        ],
        validator: 'string',
      },
      {
        type: 'input',
        inputType: 'text',
        label: 'APN',
        placeholder: 'APN Code',
        model: 'apn',
        styleClasses: 'col-md-12',
        required: true,
        pattern: /^((\w{5}-)?\w*)$/g,
        validator: 'regexp',
        visible(model) {
          return model && model.apnOrAddress === 'apn';
        },
      },
    ],
  }),
  options: helper.options('search-entity-', true),
};



// WEBPACK FOOTER //
// ./src/components/utils/properties/schemas/search.js